import React from 'react';
import {Link} from 'react-router-dom';
import db from "../../database";
import loading from "../../img/loading.svg";
let quizResultDB = "ScreenQuizResults";


export default class extends React.Component  {
  constructor(props) {
  super(props);
    this.state = {
      indexNonAnswered: []
    }
    this.props = props;
    this.getResult = this.getResult.bind(this);
  }

  componentDidMount () {
    db.collection('results').onSnapshot(function (querySnapshot) {
      var tempAdvice = {};
      querySnapshot.forEach(function (res) {
        if (res.data().id === 'Behavioural'){
          tempAdvice.behavioural = {
            low: res.data().low,
            borderline: res.data().medium,
            high: res.data().high
          }
        }
        if (res.data().id === 'Emotional'){
          tempAdvice.emotional = {
            low:res.data().low,
            borderline: res.data().medium,
            high: res.data().high
          }
        }
      })
      this.setState({
        content: tempAdvice
      })
    }.bind(this))
  }

  getResult() {
    var result = {};
    var indexNonAnswered = [];
    var currentResult = JSON.parse(sessionStorage.getItem(quizResultDB))||[];
    currentResult.forEach((v, i) => {
      if(v === null) {
        indexNonAnswered.push(i);
      } else {
        result[v.type] = (result[v.type]||0) + parseInt(v.value, 0);
      }
    });

    return {
      result: result,
      indexNonAnswered: indexNonAnswered
    };
  }

  render() {
    if (this.state.content === null || this.state.content === undefined) {
      return (<div style={{'textAlign': 'center'}} className='about-container'>
        <img src={loading} />
      </div>)
    }
    var result = this.getResult();
    var scores = result.result;
    var advice = this.state.content;
    var indexNonAnswered = result.indexNonAnswered;
    let scoreUI = {
      behavioural: {
        advice: () => {
          if(scores["behavioural"] < 6) {
            return {__html: advice.behavioural.low}
          } else if (scores["behavioural"] === 6) {
            return {__html: advice.behavioural.borderline}
          } else {
            return {__html: advice.behavioural.high}
          }
        },
        progressBar: () => {
          if(scores["behavioural"] < 6) {
            return "progress-bar-success"
          } else if (scores["behavioural"] === 6) {
            return "progress-bar-warning"
          } else {
            return "progress-bar-danger"
          }
        }
      },
      emotional: {
        advice: () => {
          if(scores["emotional"] < 10) {
            return {__html: advice.emotional.low}
          } else if (scores["emotional"] === 10 ||
                     scores["emotional"] === 11) {
            return {__html: advice.emotional.borderline}
          } else {
            return {__html: advice.emotional.high}
          }
        },
        progressBar: () => {
          if(scores["emotional"] < 10) {
            return "progress-bar-success"
          } else if (scores["emotional"] === 10 ||
                     scores["emotional"] === 11) {
            return "progress-bar-warning"
          } else {
            return "progress-bar-danger"
          }
        }
      }
    }

    var nonAnswered = [];
    indexNonAnswered.forEach((i) => {
      nonAnswered.push(<Link to={`/screen/${i}`}>Question {i}</Link>);
    });
    return (
      <div style={{"maxWidth": "400px", "margin": "auto"}}>
        <h3 className="overall-score"></h3>
        {nonAnswered}

        <h3>Behavioural Difficulties</h3>
        <p>
          <div className="progress">
            <div className={"progress-bar "+scoreUI['behavioural'].progressBar()} role="progressbar" aria-valuenow={scores["behavioural"]}
            aria-valuemin="0" aria-valuemax="12" style={{width:(scores["behavioural"]/12)*100+"%"}}>
              {scores["behavioural"]}/12
            </div>
          </div>
          <div dangerouslySetInnerHTML={scoreUI['behavioural'].advice()}></div>
          </p>
        <hr />
        <h3>Emotional Difficulties</h3>
        <p>
          <div className="progress">
            <div className={"progress-bar "+scoreUI['emotional'].progressBar()} role="progressbar" aria-valuenow={scores["emotional"]}
            aria-valuemin="0" aria-valuemax="20" style={{width:(scores["emotional"]/20)*100+"%"}}>
              {scores["emotional"]}/20
            </div>
          </div>
          <div dangerouslySetInnerHTML={scoreUI['emotional'].advice()}></div>
        </p>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Quiz/results.js